export default {
	TABLE_TITLE: 'Layouts',
	OPEN_IN_LAYOUTS: 'Open in layouts',
	TOOLIP_TEXT: 'Manage Layout in Layouts tab',
};
